
const  mainPermissionList=
{
    
        getWebMenuList:'S.AVC.AVC.getWebMenuList.Full',
        me:'S.AVC.AVC.me.Full',
        getReal:'S.AVC.AVC.getReal.Full',
        getLegal:'S.AVC.AVC.getLegal.Full',
        activeSiteList :'S.AVC.AVC.activeSiteList.Full',
    
}

export const UsefulSectionPermissionList=
{
        checkNewMessage: "S.AVC.AVC.CommonMenus.checkNewMessage.Full"
}

export default  mainPermissionList